import type { PlayerConfig } from '@movingimage-evp/player-library';

import i18next from 'i18next';

import { getSessionStorageItem } from '../utils/session-storage';

export type VideoData = {
  title: string;
  playerData: Exclude<PlayerConfig, 'metadata'> & {
    metadata: { title?: string; durationInMs?: number; videoId?: string };
  };
  structuredData: {
    uploadDate: string;
  };
};

export const fetchVideoDetails = async ({
  playoutUrl,
  videoId,
  videoToken,
}: {
  playoutUrl: string;
  videoId: string;
  videoToken?: string;
}) => {
  let response: Response;

  try {
    const token = getSessionStorageItem('viewerAccessToken');
    const url = `${playoutUrl}${videoToken ? `&token=${videoToken}` : ''}`;
    response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  } catch {
    throw new Error(i18next.t('translations:common.videoDetails.failedMessage', { videoId }));
  }

  if (!response?.ok) throw response;

  let json: VideoData;

  try {
    json = await response.json();
  } catch {
    throw new Error(i18next.t('translations:common.videoDetails.failedJSONMessage', { videoId }));
  }

  // Subtitle tracks need to have an ID to be displayed in the Player and hide React duplicated keys warning
  const playerConfigWithSubtitleIds = {
    ...json,
    playerData: {
      ...json.playerData,
      tracks: json.playerData.tracks?.map((track, index) => ({ ...track, id: `${index}-${track.srclang}` })),
    },
  };

  return playerConfigWithSubtitleIds;
};
